export const TOKEN_GRAPH_API = 'TOKEN_GRAPH_API'